import { useEffect, useRef } from 'preact/hooks'
import useForceUpdateOnResize from './useForceUpdateOnResize'
import { useAppContext } from '../contexts/AppContext'
import { STEPS } from '../constants'

const SWITCH_SLIDE_EVENT = 'WP-slide-switch'

function useHorizontalSliderMethods(isAcReady) {
  const { viewMode, acRootRef } = useAppContext()
  if (viewMode !== 'funnel') return

  const scrollContainer = useRef(null)
  const updater = useForceUpdateOnResize()
  const step = useRef(0)

  useEffect(async () => {
    if (!scrollContainer.current) return
    let stepCounter = 0

    const scopes = [...acRootRef.current.shadowRoot.querySelectorAll('[data-separator-scope]')]

    const stepsNumber = scopes.map(() => {
      return { type: stepCounter === 0 ? 'first' : null, step: stepCounter++, stepsNumber: scopes.length }
    })

    stepsNumber.push({
      type: 'last',
      step: stepsNumber.length,
      stepsNumber: stepsNumber.length,
    })

    const stepSize = scrollContainer.current.scrollWidth / stepsNumber.length

    scrollContainer.current?.scrollTo({
      left: stepSize * step.current,
    })

    window.AC_next = () => {
      dispatchEvent(new CustomEvent(SWITCH_SLIDE_EVENT))
      scrollContainer.current?.scrollTo({
        left: stepSize * (step.current + STEPS),
        behavior: 'smooth',
      })
      if (stepsNumber[step.current].type !== 'last') step.current++

      return stepsNumber[step.current]
    }

    window.AC_prev = () => {
      dispatchEvent(new CustomEvent(SWITCH_SLIDE_EVENT))
      scrollContainer.current?.scrollTo({
        left: stepSize * (step.current - STEPS),
        behavior: 'smooth',
      })

      if (stepsNumber[step.current].type !== 'first') step.current--

      return stepsNumber[step.current]
    }

    window.AC_getStep = () => {
      return stepsNumber[step.current]
    }
  }, [updater, isAcReady])

  return scrollContainer
}

export default useHorizontalSliderMethods
